export default {
    "export": {
        "library_folder": {
            "class": "app\\build\\global\\exportImport\\services\\FolderExportService",
            "permissions": []
        },
        "card": {
            "class": "app\\build\\global\\exportImport\\services\\CardExportService",
            "permissions": []
        },
        "evaluation": {
            "class": "app\\modules\\evaluation\\exportImport\\services\\EvaluationExportService",
            "permissions": []
        },
        "talent_matrix": {
            "class": "app\\modules\\talentMatrix\\exportImport\\services\\TalentMatrixExportService",
            "permissions": []
        }
    },
    "import": {
        "users": {
            "class": "app\\build\\global\\exportImport\\services\\UsersImportService",
            "permissions": [],
            "example": "UsersImport.xlsx"
        },
        "matrix_productivity_potential": {
            "class": "app\\modules\\talentMatrix\\exportImport\\services\\MatrixPotentialProductivityImportService",
            "permissions": [],
            "example": "MatrixPotentialProductivityImport.xlsx"
        }
    }
}